import { render, staticRenderFns } from "./yc-cost-page.vue?vue&type=template&id=f8866ea4&scoped=true&"
import script from "./yc-cost-page.vue?vue&type=script&lang=js&"
export * from "./yc-cost-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8866ea4",
  null
  
)

export default component.exports